if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      /* rg-resilience 2026-07-19: reset the "did we actually navigate" flag each
         submit. The finally() below used to keep the spinner running whenever the
         checkout fast-path COULD have fired -- but on a dropped/failed /cart/add
         the redirect never happens, so the button span forever and the shopper
         was stuck until reload. We now only keep spinning when navigation truly
         started, and we bound the request with a timeout so it can never hang. */
      this.__rgNavigating = false;

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      /* Abort a stalled add-to-cart after 20s (flaky wifi) so the button
         recovers instead of spinning indefinitely. */
      var __rgAbort = ('AbortController' in window) ? new AbortController() : null;
      if (__rgAbort) config.signal = __rgAbort.signal;
      var __rgTimer = setTimeout(function () { if (__rgAbort) __rgAbort.abort(); }, 20000);

      // Decide the checkout fast-path FIRST. When skip-cart is on we redirect
      // straight to /checkout, so there is no point asking Shopify to render
      // cart-drawer section HTML (that round-trip is pure lag on this path).
      this.skipCart = false;
      const idInput = this.form.querySelector('[name=id]');
      if (idInput.dataset.skipCart && idInput.dataset.skipCart === 'true') {
        this.skipCart = true;
      }

      var formData = new FormData(this.form);
      if (this.cart && !this.skipCart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      this.formIdInputValue = this.form.querySelector('[name=id]').value;
      if (this.formIdInputValue.includes(',')) {
          formData.delete('id');
          formData.delete('quantity');
      } 
      
      config.body = formData;

      const doFetch = () => fetch(`${routes.cart_add_url}`, config);
      doFetch()
        .then((response) => {
          /* rate-limited (429 returns an HTML page): one quiet retry after
             1.8s -- otherwise the drawer just silently never opens */
          if (response.status === 429 && !this.__rgRetried) {
            this.__rgRetried = true;
            return new Promise((res) => setTimeout(res, 1800)).then(doFetch);
          }
          this.__rgRetried = false;
          return response;
        })
        .then((response) => {
          /* CHECKOUT FAST-PATH: the moment the item is added, go. Don't parse
             the (unused) JSON/section payload first -- that parse is what made
             the redirect feel laggy.
             Two cases hit this path:
               - skip-cart button: straight to /checkout
               - no cart drawer/notification on the page, i.e. this.cart is null.
                 The old code sent these to /cart, which the store then bounced
                 to /checkout -- a slow double navigation. Go direct instead.
             Keep the button spinning through the nav (no flicker-back). */
          if ((this.skipCart || !this.cart) && response.ok) {
            this.__rgNavigating = true; // we are truly leaving the page now
            window.location = '/checkout';
            return null;
          }
          return response.json();
        })
        .then((response) => {
          if (response === null) return; // already redirecting to checkout
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
          /* rg-resilience: network failure or 20s timeout -- the item was NOT
             added, so let the shopper simply tap again. Surface the theme's
             existing error message if that element exists (no new UI). */
          this.error = false;
          this.__rgNavigating = false;
          this.handleErrorMessage('Something went wrong. Please tap Add to Cart again.');
        })
        .finally(() => {
          clearTimeout(__rgTimer);
          /* Only keep the spinner while we are genuinely navigating to checkout.
             (Previously this guessed from skipCart/!cart, which stayed true on a
             failed request and left the button dead + spinning forever.) */
          if (this.__rgNavigating) return;
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

